export const lightTheme = {
    body: '#FFF',
    text: '#363537',
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    tituloFiltro: '#6c757d',
    tituloContenedor: '#3498DB',
    backgroundVolverHover: '#dedede',
    success: '#28a745',
    successHover: '#1d8a35',
    danger: '#dc3545',
    dangerHover: '#b20c1c',
    info: '#1d8a35',
    infoHover: '#0e6922',
    backgroundAlerta: '#d1ecf1',
    textAlerta: '#0c5460',
    watermarkTextColor: 'rgba(22, 122, 45, 0.5)',
    
}
  
export const darkTheme = {
    body: '#363537',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    backgroundContenedor: '#4c4c4d',
    tituloFiltro: '#FFF',
    tituloContenedor: '#7acaff',
    backgroundVolverHover: '#222',
    success: '#1d8a35',
    successHover: '#0e6922',
    danger: '#c91022',
    dangerHover: '#b20c1c',
    info: '#1d8a35',
    infoHover: '#0e6922',
    backgroundAlerta: '#0c5460',
    textAlerta: '#d1ecf1',
    watermarkTextColor: 'rgba(170, 201, 113, 0.75)',
    

}
